"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageKeys = exports.checkTokenValidity = exports.getTokenResponse = exports.validateToken = exports.setToken = exports.setTan = exports.getTan = exports.getUserAuthInfo = exports.signOut = exports.setItemInStorage = exports.getItemFromStorage = void 0;
var proxyApi_1 = require("../constants/proxyApi");
var proxyApi_2 = __importDefault(require("../services/proxyApi"));
var jwt_1 = require("../constants/jwt");
var storage_1 = __importDefault(require("../constants/storage"));
var jwt_2 = require("./jwt");
var deleteAllCookies = function () {
    var cookies = document.cookie.split(';');
    cookies.forEach(function (cookie) {
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = "".concat(name, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT");
    });
};
var getItemFromStorage = function (key) { return localStorage.getItem(key); };
exports.getItemFromStorage = getItemFromStorage;
var setItemInStorage = function (key, value) { return localStorage.setItem(key, value); };
exports.setItemInStorage = setItemInStorage;
var signOut = function (preventRedirect) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        sessionStorage.clear();
        localStorage.clear();
        deleteAllCookies();
        if (!preventRedirect) {
            process.nextTick(function () {
                window.location.href = window.location.origin;
            });
        }
        return [2 /*return*/];
    });
}); };
exports.signOut = signOut;
var verifyPromise = function (token) { return new Promise(function (resolve, reject) {
    (0, jwt_2.verify)(token, function (err, decoded) {
        if (err) {
            reject(err);
            return;
        }
        resolve(decoded);
    });
}); };
var getUserAuthInfo = function () { return new Promise(function (resolve, reject) {
    var token = localStorage.getItem(storage_1.default.LOCAL_STORAGE.TELEMATICS.USER_AUTH_INFO);
    if (!token) {
        reject(new Error('token not found'));
        return;
    }
    (0, jwt_2.verify)(token, function (err, decoded) {
        if (err) {
            reject(err);
            return;
        }
        resolve(decoded);
    });
}); };
exports.getUserAuthInfo = getUserAuthInfo;
var getTan = function () { return (0, exports.getItemFromStorage)(storage_1.default.LOCAL_STORAGE.TELEMATICS.TAN)
    || process.env.REACT_APP_USER_TAN
    || ''; };
exports.getTan = getTan;
var setTan = function (tan) {
    (0, exports.setItemInStorage)(storage_1.default.LOCAL_STORAGE.TELEMATICS.TAN, tan);
};
exports.setTan = setTan;
var setToken = function (adalResponse) { return new Promise(function (resolve, reject) {
    var signatureTimestamp = Date.now();
    (0, jwt_2.sign)(__assign(__assign({}, adalResponse), { signatureTimestamp: signatureTimestamp }), { expiresIn: jwt_1.tokenExpiresIn }, function (err, token) {
        if (err) {
            reject(err);
            return;
        }
        localStorage.setItem(storage_1.default.LOCAL_STORAGE.TELEMATICS.TOKEN, token);
        resolve(token);
    });
}); };
exports.setToken = setToken;
var refreshToken = function (decoded) { return new Promise(function (resolve, reject) {
    proxyApi_2.default.request({
        url: proxyApi_1.PROXY_API.GET.SIGN_IN.REFRESH_TOKEN,
        headers: { 'Application-Token': decoded.refreshToken },
        method: 'GET',
    })
        .then(function (response) {
        resolve(__assign(__assign({}, decoded), { bearerToken: response.data.id_token, refreshToken: response.data.refresh_token }));
    })
        .catch(reject);
}); };
var validateToken = function (decoded) { return new Promise(function (resolve, reject) {
    var signatureTimestamp = decoded.signatureTimestamp;
    var currentTime = Date.now();
    var stale = currentTime - signatureTimestamp;
    if (stale > jwt_1.tokenRefreshInterval) {
        refreshToken(decoded).then(function (newDecoded) {
            (0, exports.setToken)(newDecoded);
            resolve(newDecoded);
        }).catch(reject);
    }
    resolve(decoded);
}); };
exports.validateToken = validateToken;
var getTokenResponse = function () { return new Promise(function (resolve, reject) {
    var token = process.env.REACT_APP_AUTH_TOKEN || localStorage.getItem(storage_1.default.LOCAL_STORAGE.TELEMATICS.TOKEN);
    if (!token) {
        (0, exports.signOut)();
        reject(new Error('token not found'));
        return;
    }
    (0, jwt_2.verify)(token, function (err, decoded) {
        if (err) {
            (0, exports.signOut)();
            reject(err);
            return;
        }
        (0, exports.validateToken)(decoded).then(resolve).catch(reject);
    });
}); };
exports.getTokenResponse = getTokenResponse;
var checkTokenValidity = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, decoded, signatureTimestamp, currentTime, stale, refreshedToken, e_1, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = process.env.REACT_APP_AUTH_TOKEN || localStorage.getItem(storage_1.default.LOCAL_STORAGE.TELEMATICS.TOKEN);
                if (!token) {
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                return [4 /*yield*/, verifyPromise(token)];
            case 2:
                decoded = _a.sent();
                signatureTimestamp = decoded.signatureTimestamp;
                currentTime = Date.now();
                stale = currentTime - signatureTimestamp;
                if (!(stale > jwt_1.tokenRefreshInterval)) return [3 /*break*/, 7];
                _a.label = 3;
            case 3:
                _a.trys.push([3, 6, , 7]);
                return [4 /*yield*/, refreshToken(decoded)];
            case 4:
                refreshedToken = _a.sent();
                return [4 /*yield*/, (0, exports.setToken)(refreshedToken)];
            case 5:
                _a.sent();
                return [3 /*break*/, 7];
            case 6:
                e_1 = _a.sent();
                console.error('[checkTokenValidity] Failed to refresh token', e_1);
                (0, exports.signOut)();
                return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 9];
            case 8:
                e_2 = _a.sent();
                console.error('[checkTokenValidity] Token verification failed', e_2);
                (0, exports.signOut)();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}); };
exports.checkTokenValidity = checkTokenValidity;
exports.localStorageKeys = storage_1.default.LOCAL_STORAGE;
